var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen"},[_c('i',{staticClass:"sz ",class:_vm.isFullscreen?'szln_quanpingtuichu':'szquanping',on:{"click":_vm.click}})])}
var staticRenderFns = []

export { render, staticRenderFns }